// extracted by mini-css-extract-plugin
export default {"container":"wiXsiUomRvem20uC1KAb","card":"HL37uj3GsbD7hVm2ZkfH","title":"SCxT32PmQkIMaIeTUz4C"};